import type { ExactTheme } from "src/lib/emotion/theme.ts";
import { css } from "@emotion/react";

export const root = (theme: ExactTheme) =>
  css({
    position: "relative",
    background: "white",
    width: "678px",
    borderRadius: theme.borderRadiusV2.primary,
    height: "100%",
    minHeight: "0px",
    overflow: "hidden",
  });

export const totals = css`
  padding: 15px;
  display: flex;
  align-items: center;
  justify-content: end;
  gap: 20px;
`;

export const emptyStateContainer = css({
  paddingTop: 60,
  paddingLeft: 15,
  paddingRight: 15,
  paddingBottom: 30,
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  textAlign: "center",
  justifyContent: "center",
});

export const emptyOrderStateImage = (theme: ExactTheme) =>
  css({
    marginTop: 20,
    color: theme.colorsV2.grey[600],
  });

export const positionsContainer = css({
  padding: 15,
  flexGrow: 1,
  minHeight: 0,
  overflow: "auto",
  gap: 5,
});

export const footer = css({
  padding: 25,
  flexShrink: 0,
  minHeight: 0,
});
